import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidWorkHard } from "./static.workHardData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"

class WorkHardNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidWorkHard(data))
      onSetSuccessValidate("workHard")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["workHard", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(WorkHardNextStepButton)